import { connect } from 'react-redux';
import type { IReduxState } from '../../../../../configureStore';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { RequestReadButtons } from '../../../../elements/carePathButtons/RequestReadButtons';
import { getStatusLabel } from '../../../../elements/getStatusLabel';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { GgzbMindV1FollowingSteps } from './GgzbMindV1FollowingSteps';

interface IInnerGgzbMindReadReduxProps {
    organizationId: string;
    practitionerId: string;
}

const mapStateToProps = ({ authentication }: IReduxState): IInnerGgzbMindReadReduxProps => ({
    practitionerId: authentication.id,
    organizationId: authentication.organizationId,
});

function InnerGgzbMindV1RequestRead(props: ICustomControlRequestReadProps & IInnerGgzbMindReadReduxProps) {
    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                date={props.process.dateSent || props.request?.dateSent}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) =>
                    await props.updateItemState({
                        ...props.itemState,
                        isOpen: isOpened || !!props.itemState.initialIsOpen,
                    })
                }
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={{ ...props.process, statusLabel: getStatusLabel(props.process) }}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />
            <GgzbMindV1FollowingSteps />
            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                {props.request.status === RequestStatus.draft && <RequestReadButtons {...props} />}
            </CustomControlCollapseBody>

            {!props.itemState.initialIsOpen && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('request.hideCounseling')}
                    labelMore={translateKey('request.showCounseling')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}
        </ProcessContainer>
    );
}

export const GgzbMindV1RequestRead = connect(mapStateToProps)(InnerGgzbMindV1RequestRead);
